/**
 * Валидация `?returnTo=<encoded>` (Блок 8, Фаза F2). COORD §«returnTo строго
 * внутренний относительный путь (анти-open-redirect)».
 *
 * `returnTo` — адрес возврата в калькулятор-анкету, откуда пользователь пришёл
 * («сходил-посмотрел-вернулся», решение Aibek 2026-06-14). По «Назад» каталог ведёт
 * на него (R3: persistent intent). Источник — внешний URL → **доверять нельзя**:
 * принимаем ТОЛЬКО внутренний относительный путь, иначе open-redirect (увод на
 * чужой домен через `//evil.com`, `https://…`, `/\evil`).
 *
 * Безопасный returnTo: начинается с одиночного `/`, НЕ `//` и НЕ `/\`
 * (protocol-relative), без схемы (`scheme:`). Иначе → `null` (caller игнорирует,
 * fallback на обычное «Назад» P-036).
 */
export function safeReturnTo(value: string | null | undefined): string | null {
  if (!value) return null;
  // Должен быть относительным внутренним путём.
  if (!value.startsWith('/')) return null;
  // protocol-relative `//host` или `/\host` → внешний редирект.
  if (value.startsWith('//') || value.startsWith('/\\')) return null;
  // Главный страж: резолвим относительно фиктивного origin. Если итоговый origin —
  // не наш, значит value увёл на чужой хост (в т.ч. через tab/CR/LF, которые WHATWG-URL
  // вырезает: `/<tab>//evil` → `//evil`). Тогда → null. Любой in-app относительный путь
  // остаётся на этом origin и пропускается (navigate() держит его внутри SPA).
  try {
    const u = new URL(value, 'https://internal.invalid');
    if (u.origin !== 'https://internal.invalid') return null;
  } catch {
    return null;
  }
  return value;
}
